import { useNavigate, useSearchParams } from 'react-router-dom';
import type { FunnelData } from '@/types';

interface FunnelStatsProps {
  data: FunnelData | null;
  vacancyId: string;
}

const stages = [
  { key: 'total' as const, label: 'Откликнулись', icon: 'ri-inbox-line', color: 'bg-primary-500 text-white', border: 'border-primary-500' },
  { key: 'invited' as const, label: 'Получили письмо', icon: 'ri-mail-send-line', color: 'bg-secondary-500 text-white', border: 'border-secondary-500' },
  { key: 'responded' as const, label: 'Ответили', icon: 'ri-chat-1-line', color: 'bg-accent-500 text-white', border: 'border-accent-500' },
  { key: 'answered' as const, label: 'Заполнили анкету', icon: 'ri-article-line', color: 'bg-purple-500 text-white', border: 'border-purple-500' },
];

export default function FunnelStats({ data, vacancyId }: FunnelStatsProps) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const activeStage = searchParams.get('stage');

  if (!data) return null;

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mb-6"
    >
      {stages.map((stage) => {
        const count = data[stage.key] || 0;
        return (
          <button
            key={stage.key}
            onClick={() => navigate(activeStage === stage.key
              ? `/candidates?vacancy=${vacancyId}`
              : `/candidates?vacancy=${vacancyId}&stage=${stage.key}`)}
            className={`text-left p-4 rounded-xl border-2 ${stage.border} ${stage.color} transition-all hover:opacity-90 cursor-pointer ${activeStage && activeStage !== stage.key ? 'opacity-50' : ''}`}
          >
            <div className="flex items-center justify-between mb-2"
            >
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-white/20"
              >
                <i className={`${stage.icon} text-lg`}></i>
              </span>
              <span className="text-2xl font-heading font-bold">{count}</span>
            </div>
            <p className="text-sm font-medium opacity-90">{stage.label}</p>
          </button>
        );
      })}
    </div>
  );
}